
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AstrologyPage = lazy(() => import('../pages/astrology/page'));
const BaziPage = lazy(() => import('../pages/bazi/page'));
const TarotPage = lazy(() => import('../pages/tarot/page'));
const ZiweiPage = lazy(() => import('../pages/ziwei/page'));
const BookingPage = lazy(() => import('../pages/booking/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const RegisterPage = lazy(() => import('../pages/register/page'));
const ChatPage = lazy(() => import('../pages/chat/page'));
const MasterProfilePage = lazy(() => import('../pages/master-profile/page'));
const NewsPage = lazy(() => import('../pages/news/page'));
const NewsDetailPage = lazy(() => import('../pages/news-detail/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/astrology',
    element: <AstrologyPage />,
  },
  {
    path: '/bazi',
    element: <BaziPage />,
  },
  {
    path: '/tarot',
    element: <TarotPage />,
  },
  {
    path: '/ziwei',
    element: <ZiweiPage />,
  },
  {
    path: '/booking',
    element: <BookingPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/register',
    element: <RegisterPage />,
  },
  {
    path: '/chat',
    element: <ChatPage />,
  },
  {
    path: '/master/:masterId',
    element: <MasterProfilePage />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '/news/:id',
    element: <NewsDetailPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
